<app-search-bar
    [collectionSlug]="collectionSlug"
    [collectionTitle]="searchInfo.title"
    [colors]="searchInfo.colors"
    [logo]="searchInfo.whiteLogo"
    class="gtm-search-collection-page"
>
</app-search-bar>
<div class="p-0 p-md-8 mw-1400 m-auto gtm-search-collection-page">
    <div class="row-auto g-0 me-md-n4 ms-md-n4">
        <div class="p-0 p-md-1 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
            <div id="facetsWrapper">
                <div class="facet-wrapper">
                    <app-facets [premiumCollectionSearch]="true"></app-facets>
                </div>
            </div>
        </div>
        <div class="p-0 p-md-1 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-9">
            <div id="resultsWrapper">
                <app-collection-search-result-group
                    [collectionSlug]="collectionSlug"
                    [searchInfo]="searchInfo"
                ></app-collection-search-result-group>
            </div>
        </div>
    </div>
</div>
<app-available-features></app-available-features>
